define(['jquery'], function ($) {
    "use strict";
    return MinicartComponent =>
        MinicartComponent.extend({
            loadedItems: [],
            minicartProductAddition: false,

            /*
             * Initialization should also watch for add to cart events from the minicart
             * Products and should not update the shown cart items if the item is added
             * from the minicart.
             */
            initialize: function () {

                $(document).on('minicart:addToCart', function(e, data) {
                    this.minicartProductAddition = true;
                }.bind(this));

                return this._super();
            },

            /**
             * Original function shows oldest items in the cart first
             * With the crop project, we only want to show the newest added item in the cart
             * As long as the newest item isn't added from the minicart itself (crosssell)
             * @returns []
             */
            getCartItems: function () {

                if (this.minicartProductAddition) {
                    return this.loadedItems;
                }

                this.loadedItems = this.getCartParamUnsanitizedHtml('last_added_item') || {};

                // Return this data if it exsits
                if (Object.keys(this.loadedItems).length > 0) {
                    return [this.loadedItems];
                }

                // Fallback to last added cart item if our custom data isn't present for some reason
                var cartItems = this.getCartParamUnsanitizedHtml('items') || [];
                return cartItems.slice(0, parseInt(this.maxItemsToDisplay, 10));
            }
        });
});
